module.exports = __webpack_public_path__ + "img/medsyn_logo_white_small.624e1d8a.png";